export const createReducer = (initialState = {}, handlers = new Map()) => {
  // If handlers is a plain object, convert it to a Map for safer dispatch
  const handlerMap =
    handlers instanceof Map ? handlers : new Map(Object.entries(handlers));
  return (state = initialState, action = {}) => {
    if (
      handlerMap.has(action.type) &&
      typeof handlerMap.get(action.type) === 'function'
    ) {
      return { ...state, ...handlerMap.get(action.type)(state, action) };
    }
    return state;
  };
};
